import { render, staticRenderFns } from "./admin-header.vue?vue&type=template&id=b20528a0"
import script from "./admin-header.vue?vue&type=script&lang=js"
export * from "./admin-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports